export default {
  colorPrimary: {
    backgroundColor: '#f8f8f8'
  }
};
